import { AppDefinition } from '../../types/apps';

export const INGEST_WIZARD_EVENTS = {
  FILE_UPLOADED: 'ingestWizard:file:uploaded',
  INTEGRATION_CONNECTED: 'ingestWizard:integration:connected',
  ENTITY_DISCOVERED: 'ingestWizard:entity:discovered',
  USE_CASE_COMPLETED: 'ingestWizard:useCase:completed',
  CHECKLIST_UPDATED: 'ingestWizard:checklist:updated',
  WIZARD_COMPLETED: 'ingestWizard:wizard:completed',
} as const;

export const IngestWizardDefinition: AppDefinition = {
  appId: 'ingestWizard',
  name: 'Ingest Wizard',
  version: '1.0.0',
  description: 'Intelligent setup wizard for bootstrapping new companies, projects, or workflows with guided data ingestion and progress tracking',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'MagicWand',
    phosphorWeight: 'duotone',
    color: '#7c3aed',
  },
  events: INGEST_WIZARD_EVENTS,
  entityTypes: ['File', 'Group', 'Company', 'Person', 'Service', 'Document'],
  component: 'IngestWizard',
  requiresProps: false,
  requiresEntity: false,
  hotkeys: {
    'cmd+u': 'uploadFiles',
    'cmd+i': 'connectIntegration',
    'cmd+t': 'selectUseCase',
    'cmd+s': 'scanFiles',
    'cmd+enter': 'completeWizard',
  },
  features: [
    'Guided 3-column setup wizard interface',
    'Drag & drop file/folder ingestion with AI analysis',
    'Real-time entity discovery and smart categorization',
    'Core integration system (Gmail, Google Drive, Stripe Atlas)',
    'Local file scanner tools and mobile upload',
    'Use case templates (Company Setup, Tax Prep, Research Lab)',
    'Progress tracking with intelligent checklists',
    'Live processing logs and entity inventory',
    'Smart suggestions based on discovered entities',
    'Seamless handoff to appropriate apps',
  ],
  experimental: true,
};

export default IngestWizardDefinition; 